import ProcessTerminated from "common/components/process-terminated";
import { useAppSelector } from "core/store/hooks";
import { invitationInvitationSelector } from "../_redux/selectors";

const ProcessoTerminatoInvitation: React.FC = () => {
	const invitation = useAppSelector(invitationInvitationSelector);

	const handleClick = () => {
		window.location.href = "https://buffettifinance.com/";
	};

	return (
		<div className="container d-flex align-items-center min-vh-100">
			<ProcessTerminated
				title="Il processo è andato a buon fine!"
				text={
					<div>
						<p style={{ textAlign: "justify" }}>
							La ringraziamo per la collaborazione!{" "}
							<b>
								{invitation?.rappLegaleFirstName?.toUpperCase()}{" "}
								{invitation?.rappLegaleLastName?.toUpperCase()}
							</b>{" "}
							sarà avvisato del buon esito della compilazione.
						</p>
					</div>
				}
				button="Ok, ho capito"
				onClick={handleClick}
			/>
		</div>
	);
};

export default ProcessoTerminatoInvitation;
